import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('conversation/participants')

export const FETCH_PARTICIPANTS = makeConstant('FETCH_PARTICIPANTS')
export const FETCH_PARTICIPANTS_PENDING = makeConstant('FETCH_PARTICIPANTS_PENDING')
export const FETCH_PARTICIPANTS_FAILED = makeConstant('FETCH_PARTICIPANTS_FAILED')
export const FETCH_PARTICIPANTS_CANCELLED = makeConstant('FETCH_PARTICIPANTS_CANCELLED')
export const RECEIVE_PARTICIPANTS = makeConstant('RECEIVE_PARTICIPANTS')

export const ADD_PARTICIPANTS = makeConstant('ADD_PARTICIPANTS')
export const ADD_PARTICIPANTS_PENDING = makeConstant('ADD_PARTICIPANTS_PENDING')
export const ADD_PARTICIPANTS_SUCCESS = makeConstant('ADD_PARTICIPANTS_SUCCESS')
export const ADD_PARTICIPANTS_FAILED = makeConstant('ADD_PARTICIPANTS_FAILED')

export const REMOVE_PARTICIPANTS = makeConstant('REMOVE_PARTICIPANTS')
export const REMOVE_PARTICIPANTS_PENDING = makeConstant('REMOVE_PARTICIPANTS_PENDING')
export const REMOVE_PARTICIPANTS_SUCCESS = makeConstant('REMOVE_PARTICIPANTS_SUCCESS')
export const REMOVE_PARTICIPANTS_FAILED = makeConstant('REMOVE_PARTICIPANTS_FAILED')

export const SET_MODAL_VISIBILITY = makeConstant('SET_MODAL_VISIBILITY')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/participants/constants.js